/**
 * AboutARDemoChecksFetcherView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AboutARDemoChecksFetcher
 */

import { useAboutARDemoChecksFetcherLogic } from '@/hooks/traits/useAboutARDemoChecksFetcherLogic';
import type { AboutARDemoChecksFetcherConfig } from '@/hooks/traits/useAboutARDemoChecksFetcherLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AboutARDemoCheck } from '@app/shared';
import { Alert } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface AboutARDemoChecksFetcherViewProps {
  config?: Partial<AboutARDemoChecksFetcherConfig>;
}

export function AboutARDemoChecksFetcherView({ config: propsConfig }: AboutARDemoChecksFetcherViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAboutARDemoChecksFetcherLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AboutARDemoCheck'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AboutAR" trait="AboutARDemoChecksFetcher">
      <UISlotComponent slot="toast" pattern={slotWriter['toast'] === 'ChecksLoadFailed' ? "alert" : "clear"} sourceTrait="AboutARDemoChecksFetcher">{slotWriter['toast'] === 'ChecksLoadFailed' ? (<Alert message={String(__t("std-almadar-demo-checks:checks.failed"))} variant="error" />) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AboutARDemoChecksFetcherView;
